import TranslationService from '../service/TranslationService';

function Translator(props: { value: string; }) {
    return TranslationService.translate(props.value);
}

export default Translator;
